var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityFileBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 14.6666H4.00033C3.26395 14.6666 2.66699 14.0696 2.66699 13.3333V2.66659C2.66699 1.93021 3.26395 1.33325 4.00033 1.33325H8.66699C8.67426 1.33357 8.68144 1.33491 8.68832 1.33725C8.69484 1.33926 8.70154 1.3406 8.70833 1.34125C8.76712 1.34502 8.82516 1.35645 8.88099 1.37525L8.89966 1.38125C8.91477 1.38637 8.92948 1.39261 8.94366 1.39992C9.01629 1.4322 9.08247 1.47737 9.13899 1.53325L13.139 5.53325C13.1949 5.58978 13.24 5.65596 13.2723 5.72859C13.279 5.74325 13.2837 5.75859 13.289 5.77392L13.295 5.79125C13.3136 5.84685 13.3246 5.90471 13.3277 5.96325C13.3287 5.96938 13.3303 5.9754 13.3323 5.98125C13.3335 5.9874 13.334 5.99367 13.3337 5.99992V13.3333C13.3337 14.0696 12.7367 14.6666 12.0003 14.6666ZM4.00033 2.66659V13.3333H12.0003V6.66659H8.66699C8.2988 6.66659 8.00033 6.36811 8.00033 5.99992V2.66659H4.00033ZM9.33366 3.60925V5.33325H11.0577L9.33366 3.60925Z",
    fill: "#42455F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFileBlank);
export default __webpack_public_path__ + "static/media/activity-file-blank.d4294b11.svg";
export { ForwardRef as ReactComponent };